import { Text } from '@shared/components'
import { Button, Collapse, Flex, Form } from 'antd'
import { Trash } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { ItemField } from './ItemField'
import { usePropertyInsuranceValues } from './PropertyInsuranceContext'
import { formProps } from './utils'

export const ItemsList = () => {
  const { t } = useTranslation()
  const { itemsKey } = formProps(t)
  const formInstance = Form.useFormInstance()
  const { isEditable } = usePropertyInsuranceValues()

  return (
    <Flex vertical gap={16}>
      <Text size={18} strong>
        {t('property_items_list')}
      </Text>

      <Form.List name={itemsKey.name}>
        {(fields, { add, remove }) => (
          <Flex vertical gap={16}>
            <Collapse
              key={fields.length}
              defaultActiveKey={fields
                .slice(0, 10)
                .map(({ name }) => String(name))}
              items={fields.map((field) => ({
                key: String(field.name),
                label: t('item_number', {
                  number: field.name + 1,
                  name:
                    formInstance.getFieldValue([
                      itemsKey.name,
                      field.name,
                      'name'
                    ]) || ''
                }),
                extra: !isEditable && (
                  <Button
                    type="primary"
                    icon={<Trash size={16} />}
                    disabled={fields.length === 1}
                    onClick={(e) => {
                      e.stopPropagation()
                      remove(field.name)
                    }}
                  />
                ),
                children: <ItemField field={field} />
              }))}
            />

            {!isEditable && (
              <Flex justify="end">
                <Button type="primary" onClick={() => add()}>
                  {t('add_new_object')}
                </Button>
              </Flex>
            )}
          </Flex>
        )}
      </Form.List>
    </Flex>
  )
}
